export default (path) => {
  // check for consecutive slashes
  const regex = /\/{2,}/g;
  return path.replace(regex, '/');
};
